import React from 'react'
import { Card, Carousel, CarouselItem, Col, Row } from 'react-bootstrap'

const VirtualWorlds = () => {
  return (
    <>
         <Card className='no-border rounded-0 container virtual-worlds text-center'>
            <Card className='no-border rounded-0 virtual-worlds-child'>
                <Card.Title className='virtual-worlds-title'> バーチャルワールド </Card.Title>
                <Card.Text className='virtual-worlds-text text-left'>
                2020年以降、私たちの世界はより一層グローバルにつながり、家にいながら場所や人、イベントを訪れることができるようになりました。そのためには、バーチャルワールドの創造が必要です。
                <br />
                <br /> 
                バーチャルワールドには、現実の場所を再現したもの、リアルとファンタジーを融合させたもの、現実ではありえない要素を盛り込んでゼロから作り上げるものなど、さまざまな種類があります。例えば、ネパールのブッダの生誕地について学ぶ学生は、その史跡の現在の姿、紀元前623年の姿、そして時代とともに変化する姿をバーチャルで見ることができるのです。 
                <br />
                <br /> 
                ゲーム、教育、ビジネスケースなど、VR体験の基盤となるのはバーチャルワールドです。 
                </Card.Text>
            </Card>

            <Card className='no-border rounded-0 virtual-worlds-child virtual-world-bottom-section'>
                <Card.Title className='virtual-worlds-title'> 実在する場所をベースにしたバーチャルイベント空間 <br />  4K・VR徳島映画祭 </Card.Title>
                <Card.Text className='virtual-worlds-bottom-text text-left'>
                パンデミックにより、多くのイベントがネット上などのオンライン開催を余儀なくされました。私たちは「4K・VR徳島映画祭」において、参加者が没入できるような上映・イベント空間を構築しました。この映画祭では、マイクロソフト社のAltspaceVRを使用し、3日間にわたる映画祭のVR版を作成しました。その際、映画や映像のストリーミング配信、セミナー、eスポーツの3つの会場を設けました。会場では、歴史ある寄席を再現し、天井には1929年当時の広告を掲示しました。また、屋外のスペースでは、この地域の歴史的な建造物を10棟近く再現しています。
                </Card.Text>
            </Card>

            <Card className='no-border rounded-0 tokushima-movie-festival text-center'>
                <Carousel className='tokushima-carousel' interval={null} >
                    <CarouselItem>
                        <Row>
                            <Col xs={{span:12, offset:0}} md={{span:5, offset:1}}>
                                <Card className='no-border rounded-0 architectural-modeling-card p-2'>
                                    <Card.Img className='takushima-slider-images' src={"/assets/digital-twin/tokushima/tokushima_001.jpg"} />
                                    <Card.Body>
                                    <Card.Title className='architectural-modeling-footer-title'> 現実世界の会場 <br />  （参考写真） </Card.Title>
                                    </Card.Body>
                                </Card>
                            </Col>
                            <Col xs={{span:12, offset:0}} md={{span:5, offset:0}} className="tokushima-slider-right-image">
                                <Card className='no-border rounded-0 architectural-modeling-card p-2'>
                                    <Card.Img className='takushima-slider-images' src={"/assets/digital-twin/tokushima/tokushima_001_01.jpg"} />
                                    <Card.Body>
                                    <Card.Title className='architectural-modeling-footer-title'> 仮想空間（VR）の会場 <br />  （3Dモデルのレンダリング画像） </Card.Title>
                                    </Card.Body>
                                </Card>
                            </Col>
                        </Row>
                    </CarouselItem>
                    <CarouselItem>
                        <Row>
                            <Col xs={{span:12, offset:0}} md={{span:5, offset:1}}>
                                <Card className='no-border rounded-0 architectural-modeling-card p-2'>
                                    <Card.Img className='takushima-slider-images' src={"/assets/digital-twin/tokushima/tokushima_002.jpg"} />
                                    <Card.Body>
                                    <Card.Title className='architectural-modeling-footer-title'> 現実世界の会場 <br />  （参考写真） </Card.Title>
                                    </Card.Body>
                                </Card>
                            </Col>
                            <Col xs={{span:12, offset:0}} md={{span:5, offset:0}} className="tokushima-slider-right-image">
                                <Card className='no-border rounded-0 architectural-modeling-card p-2'>
                                    <Card.Img className='takushima-slider-images' src={"/assets/digital-twin/tokushima/tokushima_002_01.jpg"} />
                                    <Card.Body>
                                    <Card.Title className='architectural-modeling-footer-title'> 仮想空間（VR）の会場 <br />  （3Dモデルのレンダリング画像） </Card.Title>
                                    </Card.Body>
                                </Card>
                            </Col>
                        </Row>
                    </CarouselItem>
                    <CarouselItem>
                        <Row>
                            <Col xs={{span:12, offset:0}} md={{span:5, offset:1}}>
                                <Card className='no-border rounded-0 architectural-modeling-card p-2'>
                                    <Card.Img className='takushima-slider-images' src={"/assets/digital-twin/tokushima/tokushima_003.jpg"} />
                                    <Card.Body>
                                    <Card.Title className='architectural-modeling-footer-title'> 現実世界の会場 <br />  （参考写真） </Card.Title>
                                    </Card.Body>
                                </Card>
                            </Col>
                            <Col xs={{span:12, offset:0}} md={{span:5, offset:0}} className="tokushima-slider-right-image">
                                <Card className='no-border rounded-0 architectural-modeling-card p-2'>
                                    <Card.Img className='takushima-slider-images' src={"/assets/digital-twin/tokushima/tokushima_003_01.jpg"} />
                                    <Card.Body>
                                    <Card.Title className='architectural-modeling-footer-title'> 仮想空間（VR）の会場 <br />  （3Dモデルのレンダリング画像） </Card.Title>
                                    </Card.Body>
                                </Card>
                            </Col>
                        </Row>
                    </CarouselItem>
                    <CarouselItem>
                        <Row>
                            <Col xs={{span:12, offset:0}} md={{span:5, offset:1}}>
                                <Card className='no-border rounded-0 architectural-modeling-card p-2'>
                                    <Card.Img className='takushima-slider-images' src={"/assets/digital-twin/tokushima/tokushima_004.jpg"} />
                                    <Card.Body>
                                    <Card.Title className='architectural-modeling-footer-title'> 現実世界の会場 <br />  （参考写真） </Card.Title>
                                    </Card.Body>
                                </Card>
                            </Col>
                            <Col xs={{span:12, offset:0}} md={{span:5, offset:0}} className="tokushima-slider-right-image">
                                <Card className='no-border rounded-0 architectural-modeling-card p-2'>
                                    <Card.Img className='takushima-slider-images' src={"/assets/digital-twin/tokushima/tokushima_004_01.jpg"} />
                                    <Card.Body>
                                    <Card.Title className='architectural-modeling-footer-title'> 仮想空間（VR）の会場 <br />  （3Dモデルのレンダリング画像） </Card.Title>
                                    </Card.Body>
                                </Card>
                            </Col>
                        </Row>
                    </CarouselItem>
                    <CarouselItem>
                        <Row>
                            <Col xs={{span:12, offset:0}} md={{span:5, offset:1}}>
                                <Card className='no-border rounded-0 architectural-modeling-card p-2'>
                                    <Card.Img className='takushima-slider-images' src={"/assets/digital-twin/tokushima/tokushima_005.jpg"} />
                                    <Card.Body>
                                    <Card.Title className='architectural-modeling-footer-title'> 現実世界の会場 <br />  （参考写真） </Card.Title>
                                    </Card.Body>
                                </Card>
                            </Col>
                            <Col xs={{span:12, offset:0}} md={{span:5, offset:0}} className="tokushima-slider-right-image">
                                <Card className='no-border rounded-0 architectural-modeling-card p-2'>
                                    <Card.Img className='takushima-slider-images' src={"/assets/digital-twin/tokushima/tokushima_005_01.jpg"} />
                                    <Card.Body>
                                    <Card.Title className='architectural-modeling-footer-title'> 仮想空間（VR）の会場 <br />  （3Dモデルのレンダリング画像） </Card.Title>
                                    </Card.Body>
                                </Card>
                            </Col>
                        </Row>
                    </CarouselItem>
                    <CarouselItem>
                        <Row>
                            <Col xs={{span:12, offset:0}} md={{span:5, offset:1}}>
                                <Card className='no-border rounded-0 architectural-modeling-card p-2'>
                                    <Card.Img className='takushima-slider-images' src={"/assets/digital-twin/tokushima/tokushima_006.jpg"} />
                                    <Card.Body>
                                    <Card.Title className='architectural-modeling-footer-title'> 現実世界の会場 <br />  （参考写真） </Card.Title>
                                    </Card.Body>
                                </Card>
                            </Col>
                            <Col xs={{span:12, offset:0}} md={{span:5, offset:0}} className="tokushima-slider-right-image">
                                <Card className='no-border rounded-0 architectural-modeling-card p-2'>
                                    <Card.Img className='takushima-slider-images' src={"/assets/digital-twin/tokushima/tokushima_006_01.jpg"} />
                                    <Card.Body>
                                    <Card.Title className='architectural-modeling-footer-title'> 仮想空間（VR）の会場 <br />  （3Dモデルのレンダリング画像） </Card.Title>
                                    </Card.Body>
                                </Card>
                            </Col>
                        </Row>
                    </CarouselItem>
                    

                </Carousel>
            </Card>
            <Card className='no-border rounded-0 tokushima-video-section'>
                <Row>
                    <Col xs={{span:12, offset:0}} md={{span:8, offset:2}}>
                        <video className='tokushima-video-player container' muted loop autoPlay playsInline onContextMenu={(e) => e.preventDefault()}>
                            <source src={"/assets/digital-twin/tokushima/video/Tokushima-Festival.mp4"} type="video/mp4"/>
                        </video>
                    </Col>
                </Row>

            </Card>

        </Card>
      
    </>
  )
}

export default VirtualWorlds
